/* ==========================================================================
   UiPopper > Vendor > Config
   ========================================================================== */

const config = {
    placement: 'auto',
    offset: [0, 10],
    arrowPadding: 0
};

const setOffset = data => ({
    name: 'offset',
    options: {
        offset: data
    }
});

const setArrow = data => ({
    name: 'arrow',
    options: {
        element: '[data-uipopper-arrow]',
        padding: data
    }
});

module.exports = ({
    placement = config.placement,
    offset = config.offset,
    arrow = config.arrow,
    arrowPadding = config.arrowPadding
}) => ({
    placement,
    modifiers: [setOffset(offset), arrow ? setArrow(arrowPadding) : false]
});
